import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cart-popup__main__item__amount-selector" }
const _hoisted_2 = { class: "cart-popup__main__item__amount-selector__remove" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "cart-popup__main__item__amount-selector__add" }

import { ref, watch } from "vue";
import { DataLayerApi } from "@/services/Api";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCartAmountSelector',
  props: {
  modelValue: {
    type: Number,
    required: true,
  },
  partno: {
    type: String,
    required: true,
  },
},
  emits: {
  "update:modelValue": (value: number) => {
    return true;
  },
},
  setup(__props, { emit }) {

const props = __props;



const onMinusClick = () => {
  DataLayerApi.createRemoveFromCartEvent(props.partno, 1);
  if (props.modelValue - 1 == 1) {
    isMinusButtonDisabled.value = true;
  }
  emit("update:modelValue", props.modelValue - 1);
};
const onPlusClick = () => {
  DataLayerApi.createAddToCartEvent(props.partno, 1, "cart");
  isMinusButtonDisabled.value = false;
  emit("update:modelValue", props.modelValue + 1);
};
const isMinusButtonDisabled = ref<boolean>(props.modelValue == 1);
watch(
  () => props.modelValue,
  (currVal: number) => {
    isMinusButtonDisabled.value = currVal == 1;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_icon_remove = _resolveComponent("icon-remove")!
  const _component_icon_add = _resolveComponent("icon-add")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-minus",
        disabled: isMinusButtonDisabled.value,
        onClick: onMinusClick
      }, [
        _createVNode(_component_icon_remove)
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("input", {
      class: "form-control cart-popup__main__item__amount-selector__quantity",
      disabled: "",
      min: "0",
      name: "quantity",
      value: __props.modelValue,
      type: "number"
    }, null, 8, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn btn-plus",
        onClick: onPlusClick
      }, [
        _createVNode(_component_icon_add)
      ])
    ])
  ]))
}
}

})